import { render, staticRenderFns } from "./TabelaDePagamentosDeContasAPagar.vue?vue&type=template&id=05c00996&scoped=true"
import script from "./TabelaDePagamentosDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDePagamentosDeContasAPagar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDePagamentosDeContasAPagar.vue?vue&type=style&index=0&id=05c00996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c00996",
  null
  
)

export default component.exports